import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { downloadRequirementJd, viewRequirementJd } from '../../services/requirementService';
import { showError } from '../../utils/toast';
import { getApiErrorMessage } from '../../utils/apiError';

function RequirementJdActions({ requirement, className = '' }) {
  const [loadingAction, setLoadingAction] = useState('');
  const requirementId = requirement?._id || requirement?.id;

  if (!requirement?.jdPdf) {
    return <span className="text-muted">No JD uploaded</span>;
  }

  if (!requirementId) {
    return <span className="text-muted">Unable to load JD for this requirement.</span>;
  }

  const handleView = async () => {
    setLoadingAction('view');
    try {
      await viewRequirementJd(requirementId, requirement.jdPdfOriginalName);
    } catch (error) {
      showError(getApiErrorMessage(error, 'Unable to open JD PDF.'));
    } finally {
      setLoadingAction('');
    }
  };

  const handleDownload = async () => {
    setLoadingAction('download');
    try {
      await downloadRequirementJd(requirementId, requirement.jdPdfOriginalName);
    } catch (error) {
      showError(getApiErrorMessage(error, 'Unable to download JD PDF.'));
    } finally {
      setLoadingAction('');
    }
  };

  return (
    <div className={`d-flex flex-wrap gap-2 align-items-center ${className}`.trim()}>
      <Button
        type="button"
        variant="outline-primary"
        size="sm"
        disabled={loadingAction === 'view'}
        onClick={handleView}
      >
        {loadingAction === 'view' ? 'Opening...' : 'View JD PDF'}
      </Button>
      <Button
        type="button"
        variant="outline-secondary"
        size="sm"
        disabled={loadingAction === 'download'}
        onClick={handleDownload}
      >
        {loadingAction === 'download' ? 'Downloading...' : 'Download JD PDF'}
      </Button>
      {requirement.jdPdfOriginalName ? (
        <small className="text-muted">{requirement.jdPdfOriginalName}</small>
      ) : null}
    </div>
  );
}

export default RequirementJdActions;
